import { UserType } from "@common/types/user";
import { UserWorkspaceRole } from "@common/userWorkspaceRoles";

interface CanDeleteEntityParams {
    userType: UserType;
    workspaceRole: UserWorkspaceRole | null;
}

export function canDeleteEntity({
    userType,
    workspaceRole,
}: CanDeleteEntityParams): boolean {
    if (workspaceRole === UserWorkspaceRole.VIEW_ONLY) {
        return false;
    }
    return (
        userType === UserType.SUPPORT ||
        workspaceRole === UserWorkspaceRole.PRIMARY_ADMIN
    );
}
